<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col cols="12">
				<b-card no-body class="p-2">
					<b-form @submit="onSearchSubmit" @reset="onReset" v-if="showSearch" inline>
						<b-input-group prepend="Name" class="my-1" cols="12">
							<b-form-input v-model="search.name" type="text"></b-form-input>
						</b-input-group>
						<b-button type="submit" variant="outline-primary" class="my-1 ml-sm-2">
							<i class="fa fa-search fa-fw fa-lg"></i>
						</b-button>
						<b-button type="reset" variant="secondary" class="my-1 ml-2">
							<i class="fa fa-refresh fa-fw fa-lg"></i>
						</b-button>

						<button type="button" class="btn btn-outline-primary ml-auto" @click="onAddClick" v-if="IsNewAllowed === true">
							<i class="fa fa-plus fa-fw fa-lg"></i> Add
						</button>
					</b-form>
				</b-card>
			</b-col>
			<b-col cols="12" md="6" lg="4" v-for="document in DocumentList" :key="document.Id">
				<b-card>
					<div slot="header">
						<h5>
							<span style="color: blue;"><i :class="'fa fa-' + document.IconName + ' fa-fw fa-lg'"></i></span>
							{{document.Title}}
							<a class="btn btn-light float-right" :href="document.FileUrl" target="_blank"><i class="fa fa-download fa-fw fa-lg"></i></a>
							<a @click="onEditClick(document.Id)" v-if="IsAdminSignedIn === true" class="btn btn-light float-right mr-2"><i class="fa fa-pencil fa-fw fa-lg"></i></a>
						</h5>
					</div>
					{{document.Description}}
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import VueAxios from "@/shared/axios-instance.js";

export default {
	name: "Library",
	data() {
		return {
			DocumentList: [],
			search: {
				name: ""
			},
			showSearch: true,
			IsAddAllowed: true
		};
	},
	created() {
		this.getlist();
	},
	methods: {
		onSearchSubmit(evt) {
			evt.preventDefault();
			this.getlist();
		},
		onReset(evt) {
			evt.preventDefault();
			this.search.name = "";
			/* Trick to reset/clear native browser form validation state */
			this.showSearch = false;
			this.$nextTick(() => {
				this.showSearch = true;
			});
			this.getlist();
		},
		onAddClick() {
			this.$router.push("new");
		},
		getlist() {
			VueAxios.get(`/document?search=${this.search.name}&category=0`)
				.then(resp => {
					this.DocumentList = resp.data;
				})
				.catch(err => {
					if (err.data && err.data.Message) {
						this.$snotify.error(err.data.Message, "Error");
					} else {
						console.log(err);
					}
				});
		},
		onEditClick(Id) {
			this.$router.push("d/" + Id);
		}
	},
	computed: {
		IsAdminSignedIn() {
			return this.$myStore.getters.IsRole("Admin");
		},
		IsNewAllowed() {
			return this.$myStore.getters.Permission_IsAllowed(
				"ELibrary",
				"IsPost"
			);
		}
	}
};
</script>